import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';

@Component({
  selector: 'cb-edit-button',
  imports: [MatIconModule],
  standalone: true,
  template: `
    <button class="edit-button" [class.large]="size() === 'large'" (click)="buttonClick.emit()">
      <mat-icon svgIcon="plus" class="edit-icon"></mat-icon>
      <span class="edit-label">{{ label() }}</span>
    </button>
  `,
  styles: [
    `
      .edit-button {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        height: 38px;
        padding: 0 23px;
        background: #faf7ed;
        border: 1px solid #e5e3dc;
        border-radius: 10px;
        cursor: pointer;
        font-family: 'Asap', sans-serif;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        color: #4a443d;
        white-space: nowrap;

        &:hover {
          background: #f4f0e7;
        }

        &.large {
          height: 48px;
          padding: 0 32px;
          font-size: 18px;
        }
      }

      .edit-icon {
        width: 18px;
        height: 18px;
        color: #0f8898;
      }

      .edit-label {
        line-height: 24px;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CbEditButtonComponent {
  label = input<string>('Edit');
  size = input<'default' | 'large'>('default');
  buttonClick = output<void>();
}
